import { render, staticRenderFns } from "./maconfig.vue?vue&type=template&id=2637cc10&"
import script from "./maconfig.vue?vue&type=script&lang=js&"
export * from "./maconfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports